<script lang="ts">
  import Separator from "$components/+blocks/Separator/Separator.svelte";
  import { getContext } from "svelte";
  import { dropdownSectionKey } from "../internal/DropdownContent.svelte";
  import type { Writable } from "svelte/store";

  const sectionsRendered = getContext<Writable<number>>(dropdownSectionKey);

  // This is used to ensure the first section does not render a separator.
  const isFirstSection = $sectionsRendered === 0;

  // Increment the section counter to ensure the next section renders the separator correctly.
  $sectionsRendered++;
</script>

{#if !isFirstSection}
  <Separator />
{/if}
<slot />
